import { Grid2, Typography, Box, Modal, Slide } from "@mui/material";
import { memo, useMemo, useEffect, useState, useCallback } from "react";
import Table from "../Table";
import Spinner from "../Spinner";
import {
    metricHeader,
    registrationCodeHeader,
} from "../TableHeaders.js";
import useListStyles from "../styles/List.js";
import {
    getMetrics,
    addMetrics,
} from "../../api/index.js";
import { useSnackbar } from "../../utils/index.js";
import Form from "../Form.js";


const MilkRecordingMetricsTable = ({
    selectedMilkRecording,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [fetchedMetrics, setFetchedMetrics] = useState([]);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [selectedAnimalMilkRecording, setSelectedAnimalMilkRecording] = useState();

    const classes = useListStyles();
    const { success, error } = useSnackbar();

    const fetchData = useCallback(
        async () => {
            setIsLoading(true);
            try {
                const { metrics } = await getMetrics(selectedMilkRecording._id);
                setFetchedMetrics(metrics);
            } catch (err) {
                error(err);
            }
            setIsLoading(false);
        }
    )

    useEffect(() => {
        fetchData();
    }, []);

    const handleRegistrationCodeClick = (value) => {
        const selectedAnimalMilkRecordingObj = fetchedMetrics.find((metric) => metric.registrationCode === value)
        setSelectedAnimalMilkRecording(selectedAnimalMilkRecordingObj);
        setIsCreateOpen(true);
    }

    const tableColumns = useMemo(() => [
        registrationCodeHeader(handleRegistrationCodeClick),
        metricHeader("Αριθμός Δείγματος", "sampleNumber"),
        metricHeader("Λίπος(%)", "fat"),
        metricHeader("Πρωτεΐνη(%)", "protein"),
        metricHeader("Λακτόζη(%)", "lactose"),
        metricHeader("Σωματικά Κύτταρα(x1000)", "cells"),
    ])

    const metricsFormContent = [
        {
            customType: "input",
            id: "fat",
            type: "number",
            placeholder: "Λίπος(%)",
            value: selectedAnimalMilkRecording?.fat,
        },
        {
            customType: "input",
            id: "protein",
            type: "number",
            placeholder: "Πρωτεΐνη(%)",
            value: selectedAnimalMilkRecording?.protein,
        },
        {
            customType: "input",
            id: "lactose",
            type: "number",
            placeholder: "Λακτόζη(%)",
            value: selectedAnimalMilkRecording?.lactose,
        },
        {
            customType: "input",
            id: "cells",
            type: "number",
            placeholder: "Σωματικά Κύτταρα(x1000)",
            value: selectedAnimalMilkRecording?.cells,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή"
        },
    ];

    const handleFormSubmit = async (values) => {
        setIsLoading(true);
        const { success: scs, message } = await addMetrics(selectedAnimalMilkRecording._id, values);
        if (scs) {
            success(message);
        } else {
            error(message);
        }
        setIsCreateOpen(false);
        fetchData();
        setIsLoading(false);
    }
    return (
        <>
            <Spinner open={isLoading} />
            <Modal open={isCreateOpen} onClose={() => setIsCreateOpen(false)} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Slide direction="left" in={isCreateOpen} mountOnEnter unmountOnExit>
                    <Box className={classes.modalContent}>
                        <Typography variant="h5" className={classes.modal_title}>
                            Προσθήκη Στοιχείων
                        </Typography>
                        <Form content={metricsFormContent} onSubmit={handleFormSubmit} />
                    </Box>
                </Slide>
            </Modal>
            <Grid2 container className={classes.container} direction="column" sx={{ marginTop: "1rem", marginLeft: "3rem" }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ width: "90%", marginBottom: "1rem" }}>
                    <Typography variant="h5" className={classes.form_title}>
                        Εισαγωγή Στοιχείων Λίπους-Πρωτεΐνης-Λακτόζης
                    </Typography>
                </Box>
                <Table
                    data={fetchedMetrics}
                    noDataText={isLoading ? "Φόρτωση..." : "Δεν υπάρχουν Στοιχεία!"}
                    columns={tableColumns}
                />
            </Grid2>
        </>
    )
}

export default memo(MilkRecordingMetricsTable);